/**
 * Freee請求管理
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'
 import * as types from '../../../mutation-types/driver-types'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/sales/freee_transactions`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      billing_month: null,
      errors: false,
      keyword: null,
    },
  }
}

const sales_freee_transaction = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * Freee請求管理一覧
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param subscriber_number
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { keyword, billing_month, errors, page, limit, format }) {

      dispatch('saveCondition', {
        billing_month: billing_month,
        errors: errors,
        keyword: keyword,
        limit: limit,
      })
      const params = {
        billing_month: state.condition.billing_month,
        errors: state.condition.errors,
        keyword: state.condition.keyword,
        limit: state.condition.limit,
        page: page,
        format: format,
      }
      let api_path
      if (params.format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = `${API_PATH}`
      }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if ((params.format != 'csv')) {
            let content = data.content
            commit(types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_PAGINATION, { content })
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    saveCondition ({ commit, state }, { billing_month, errors, keyword, limit }) {
      const _billing_month = (billing_month !== undefined) ? billing_month : state.condition.billing_month
      const _errors = (errors !== undefined) ? errors : state.condition.errors
      const _keyword = (keyword !== undefined) ? keyword : state.condition.keyword
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = {
        billing_month: _billing_month,
        errors: _errors,
        keyword: _keyword,
        limit: _limit,
      }
      commit(types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_PAGINATION] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_SALES_FREEE_TRANSACTION_BILLING_CONDITION] (state, { params }) {
      state.condition.billing_month = params.billing_month
      state.condition.errors = params.errors
      state.condition.keyword = params.keyword
      state.condition.limit = params.limit
    }
  },


}
export default sales_freee_transaction
